import { SEARCH_INDICE_PRODUCTS } from '@zyro-inc/site-modules/constants/siteModulesConstants';

const PUBLIC_API = `${import.meta.env.VITE_BACKEND_API_URL}/public`;

const DEFAULT_MAX_PRODUCTS_TO_FETCH = 15;

export const search = async ({
	query,
	indices,
	pageSize = DEFAULT_MAX_PRODUCTS_TO_FETCH,
	storeId,
}: {query: string, indices: [typeof SEARCH_INDICE_PRODUCTS], pageSize?: number, storeId: string }) => {
	if (!query) {
		return [];
	}

	const response = await fetch(`${PUBLIC_API}/search`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query,
			indices,
			storeId,
			pageSize,
		}),
	});
	const { results } = await response.json();

	return results.products.hits;
};
